import { autoserialize, inheritSerialization } from 'cerialize';
import { Rider } from './rider';

@inheritSerialization(Rider)
export class RiderDetail extends Rider {
  @autoserialize
  suspended: boolean;
}
